var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Flex, Button, H6, Text, TextArea, Dialog, DialogContent } from "../../..";
export var BulkAddModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, onAdd = _a.onAdd, dialogTitle = _a.dialogTitle, subTitle = _a.subTitle;
    var _b = __read(useState(''), 2), value = _b[0], setValue = _b[1];
    var onCloseFn = function () {
        onClose();
        setValue('');
    };
    var onAddFn = function () {
        var strValues = value.split(/\n/) || [];
        onAdd(strValues);
        onCloseFn();
    };
    return (React.createElement(Dialog, { isOpen: isOpen, onClose: onCloseFn, "aria-labelledby": "bulk-add-dialog", closeOnEscPress: true, lss: { width: '90%', tablet: { width: '35rem' } } },
        React.createElement(DialogContent, { lss: { justifyContent: 'center' } },
            React.createElement(H6, { lss: { textAlign: 'center' } }, dialogTitle),
            React.createElement(Text, { as: "p", lss: { textAlign: 'center', mt: 'xs' } }, subTitle),
            React.createElement(TextArea, { style: { height: '200px' }, value: value, onChange: function (e) {
                    var value = e.target.value;
                    setValue(value);
                } }),
            React.createElement(Flex, { lss: { justifyContent: 'center', mt: 'lg' } },
                React.createElement(Button, { type: "button", onClick: onCloseFn, scale: "md", palette: "primary", emphasis: "medium", lss: { mr: 'md', width: '130px' } }, "Cancel"),
                React.createElement(Button, { type: "button", disabled: !value, onClick: onAddFn, scale: "md", palette: "secondary", lss: { width: '130px' } }, "Add")))));
};
//# sourceMappingURL=BulkAddModal.js.map